import { requireAnySystemPermission, requireOrgPermission } from '../../../../../../backend/features/permissions/shared';
import { useContactManagementTranslation, useUserState } from '../../../../../../ui/hooks';
import { ChipLight } from '@juvare/common-web-ui/ChipLight';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Badge, Box, Chip, Typography } from '@mui/material';
import React from 'react';
import { getUserMembershipStatus } from '../utils';
import { OrganizationTreeItemActions } from './OrganizationTreeItemActions';
const userStatusColorMap = {
    joined: themeColors.accent.green.bold,
    pending: themeColors.accent.orange.bold,
};
export const CustomOrganizationTreeItem = (props) => {
    var _a;
    const { t } = useContactManagementTranslation();
    const userState = useUserState();
    const itemId = props.item.id.split('_')[0];
    const userStatus = getUserMembershipStatus(userState.orgStatus, itemId);
    const canManageOrg = requireAnySystemPermission(userState, 'manage-organizations', 'all-organizations-admin') ||
        requireOrgPermission(userState, itemId, 'manage-members');
    return (React.createElement(Box, { key: itemId, sx: {
            py: { xs: 2, md: 0 },
            pr: 2,
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            gap: 1,
            flexGrow: 1,
            alignItems: { xs: undefined, sm: 'center' },
        } },
        React.createElement(Box, { sx: {
                display: 'flex',
                flexDirection: { xs: 'column', md: 'row' },
                flexGrow: 1,
                gap: 1,
                width: { xs: '100%', sm: 'calc(100% - 276px)' },
            } },
            React.createElement(Box, { sx: { display: 'flex', flexGrow: 1, alignItems: 'center', gap: 1.5, width: { xs: '100%', md: 'calc(100% - 276px)' } } },
                React.createElement(Typography, { variant: 'body2', sx: { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' } }, props.item.name),
                props.item.childrenHasPendingMembers && (React.createElement(Badge, { variant: 'dot', color: 'warning', "aria-label": t('panels.organizations.childrenHavePending') })),
                !!userStatus && (React.createElement(Chip, { sx: {
                        backgroundColor: userStatusColorMap[userStatus],
                        color: themeColors.text.inverse,
                    }, label: t(`panels.accounts.${userStatus}`), size: 'small', variant: 'filled', "data-test": 'status-chip' }))),
            canManageOrg && (React.createElement(ChipLight, { sx: { maxWidth: '164px', flexGrow: 1 }, size: 'small', label: t('panels.organizations.pendingMembershipsCount', { count: (_a = props.membershipCount) !== null && _a !== void 0 ? _a : 0 }), color: props.membershipCount > 0 ? 'warning' : 'default' }))),
        React.createElement(OrganizationTreeItemActions, { item: props.item, isFocused: props.focus, onReload: props.onReload })));
};
